import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';
import { CircularProgress, Box, Typography } from '@mui/material';

/**
 * Redirects authenticated users to dashboard, unauthenticated to login
 */
const AuthRedirect: React.FC = () => {
  const { isAuthenticated, isLoading } = useAuth0();
  const [forceRedirect, setForceRedirect] = useState(false);

  // If Auth0 is taking too long (>3 seconds), force redirect to login
  useEffect(() => {
    if (isLoading) {
      const timeout = setTimeout(() => {
        console.warn('Auth0 loading timeout - forcing redirect');
        setForceRedirect(true);
      }, 3000);

      return () => clearTimeout(timeout);
    }
  }, [isLoading]);

  if (forceRedirect && isLoading) {
    // Timeout exceeded, redirect to login
    return <Navigate to="/login" replace />;
  }

  if (isLoading) {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '100vh',
          gap: 2
        }}
      >
        <CircularProgress />
        <Typography variant="body2" color="text.secondary">
          Loading...
        </Typography>
      </Box>
    );
  }

  return isAuthenticated ? (
    <Navigate to="/dashboard" replace />
  ) : (
    <Navigate to="/login" replace />
  );
};

export default AuthRedirect;
